export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  thumbnail: string;
  author?: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug: 'the-3000-engine-gamble',
    title: 'The $3,000 Engine Gamble',
    date: '2023-01-11',
    thumbnail: '/blog/engine-gamble.jpg',
    excerpt: 'Is it worth spending money on an old car, rather than getting a new one? Here is the math that saved me from a $10,000 mistake.',
    content: `
Actually, the title is a bit of a shocker. But for me, it was real. 

A few years ago, I was staring at a 2012 Hyundai Tucson that needed a $3,000 engine overhaul. The mechanic looked at me with that "it’s a good car if you fix it" face. My gut said, *"Give it another chance."* My bank account said, *"Buying a new car is too expensive right now."*

But I didn't listen to my gut. I listened to my spreadsheet.

Since 2018, I have been tracking every single cent I spend on my cars. Not just fuel. Everything: depreciation, insurance, that random bushing that cost $40, and the "convenience" tax of car washes. 

When that $3,000 quote hit, I ran the numbers. Here is the math that most people ignore.

### The "Sunk Cost" Trap
Most people think: *"If I spend $3,000 to fix it, I have a working car again. That's cheaper than a $30,000 new car."*

That logic is a lie. 

You aren't comparing $3,000 to $30,000. You are comparing **Cost-Per-Kilometer.** 

In my Tucson’s case, the "invisible" costs were already mounting. Fuel efficiency was dropping. Resale value was cratering. Even if I fixed the engine, my cost-per-km was projected to be **0.42€/km** over the next 12 months. 

I looked at the rental market (CityBee/Bolt Drive) and the lease options for a newer, more efficient vehicle. Turning that Tucson into a "reliable tool" again was actually going to cost me 15% more than just cutting my losses and moving on.

### The Verdict
I didn't fix the car. I sold it for what it was—a project for someone else. 

I used the math to justify moving into a newer vehicle where the cost-per-km (even with a lease) was predictable and lower. 

### Why You Are Guessing
The problem is that most owners have no idea what their car actually costs. They see a repair bill as a "one-time event." It’s almost never a one-time event. It’s part of a trend.

If you don't track the trend, you’re just gambling.

I built **MyCarCosts** because I was tired of guessing. I wanted to see the "Health Score" of my investment in real-time. I wanted a button that said, "Repair or Sell?" and showed me the receipts.

If you’re staring at a big bill right now, stop guessing. Use the math. It’s the only thing that doesn't lie to you.
    `
  }
];
